import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-form';
import zenScroll from 'zenscroll';
import swal from 'sweetalert2';
import Tracking from './tracking';

const Forms = {
	Init() {
		Forms.Validation();
		Forms.AJAXForms();
	},
	Validation() {
		const $validationSummary = $('.validation-summary-errors');
		const $inputValidationError = $('.input-validation-error');

		if ($inputValidationError.length) {
			zenScroll.to($inputValidationError[0]);
			$($inputValidationError)[0].focus();
		} else if ($validationSummary.length) {
			zenScroll.to($validationSummary[0]);
		}

		$($inputValidationError).closest('.form-group').addClass('has-error');
	},
	AJAXForms() {
		Forms.AJAXFormsInit('.form-ajax--default', {
			onSuccess: (responseText, statusText, xhr, $form) => {
				Forms.ShowModalResult(responseText, statusText, xhr, $form);
				Tracking.TrackAdWordsConversion(
					`${$('body').data('google-ads-conversionid')}/${$('body').data('google-ads-conversionlabel')}`
				);
			},
			onError: (responseText, statusText, xhr, $form) => {
				Forms.ShowModalResult(responseText, statusText, xhr, $form);
			},
			onMessages: (responseText, statusText, xhr, $form) => {
				Forms.ShowModalMessages(responseText, statusText, xhr, $form);
			}
		});

		Forms.AJAXFormsInit('.form-ajax--inpage', {
			onSuccess: (responseText, statusText, xhr, $form) => {
				Forms.AddResultToPage(responseText, statusText, xhr, $form);
			},
			onError: (responseText, statusText, xhr, $form) => {
				Forms.AddResultToPage(responseText, statusText, xhr, $form);
			},
			resetForm: false
		});
	},
	AJAXFormsInit(selector, options) {
		const defaults = {
			onSuccess: null,
			onError: null,
			resetForm: true
		};

		const opts = $.extend({}, defaults, options);

		$(selector).ajaxForm({
			beforeSubmit: (arr, $form, _options) => {
				try {
					Tracking.TrackPixel($form.data('track-pixel'));
				} catch (exc) {
					// nothing to do
				}
			},
			beforeSerialize: () => {
				Forms.DisableForms();
			},
			success: (responseText, statusText, xhr, $form) => {
				switch (responseText.Status.toLowerCase()) {
					case 'complete':
						if (opts.onSuccess != null) {
							opts.onSuccess(responseText, statusText, xhr, $form);
						}
						break;
					case 'message':
						opts.resetForm = false;
						if (opts.onMessages != null) {
							opts.onMessages(responseText, statusText, xhr, $form);
						}
						break;
					default:
						if (opts.onError != null) {
							opts.onError(responseText, statusText, xhr, $form);
						}
						break;
				}
				Forms.EnableForms();
				if (opts.resetForm) {
					$form[0].reset();
				}
			},
			error: (responseText, statusText, xhr, $form) => {
				if (opts.onError != null) {
					opts.onError(responseText, statusText, xhr, $form);
				}
				Forms.EnableForms();
			}
		});
	},
	ShowModalResult(responseText, statusText, xhr, $form) {
		const responseJSON = responseText;
		Tracking.TrackPageView(responseJSON.Route);
		$('<div />').load(`${responseJSON.Route} #form-result`, function buildAlert() {
			swal.fire({
				html: $(this).html(),
				showCloseButton: true,
				// type: responseJSON.Type,
				buttonsStyling: false,
				icon: responseJSON.Status === 'Complete' ? 'success' : 'error',
				confirmButtonText: $form.data('swal-confirm-button-text'),
				customClass: {
					confirmButton: 'btn btn-indigo'
				}
			});
		});
	},
	ShowModalMessages(responseText, statusText, xhr, $form) {
		swal.fire({
			html: `<ul class="mt-2 text-left">${responseText.Errors[0]
				.map(err => `<li class="mb-2">${err.ErrorMessage}</li>`)
				.join('')}</ul>`,
			showCloseButton: true,
			buttonsStyling: false,
			icon: 'warning',
			confirmButtonText: $form.data('swal-confirm-button-text'),
			customClass: {
				confirmButton: 'btn btn-indigo'
			}
		});
	},
	AddResultToPage(responseText, statusText, xhr, $form) {
		const responseJSON = responseText;
		Tracking.TrackPageView(responseJSON.Route);

		const $target = $form.data('target');
		$($target).load(`${responseJSON.Route} #form-result`, () => {
			$($target).addClass('js--is-active');
			zenScroll.to(document.querySelector($target));

			const $targetShow = $form.data('target-show');
			if ($targetShow != null) {
				$($targetShow).removeClass('js--is-inactive');
			}
		});
	},
	DisableForms() {
		$('.btn').attr('disabled', 'disabled').addClass('btn-disabled');
	},
	EnableForms() {
		$('.btn').removeAttr('disabled').removeClass('btn-disabled');
	}
};

export default Forms;
